export default "__VITE_ASSET__BSwCn2c1__"